import React from 'react';
import {Box, Grid, Typography} from '@mui/material';

export const BuilderColumnWrapper = ({children}: {children: React.ReactNode}) => (
  <Box pt={2} pb={2} height="100%" display="flex">
    <Grid container spacing={3} justifyContent="space-around" direction="row">
      {children}
    </Grid>
  </Box>
);

interface BuilderSourceColumnHeaderProps {
  sourceLabel?: string;
  fromError?: string;
}

export const BuilderSourceColumnHeader = ({
  sourceLabel = 'Source',
  fromError,
}: BuilderSourceColumnHeaderProps) => (
  <>
    <Typography variant="h4" color={fromError ? 'error' : 'primary'}>
      <strong>
        {sourceLabel}
        {fromError ? ' (required)' : ''}:
      </strong>
    </Typography>
    <Box mt={1} />
  </>
);

interface BuilderDestinationColumnHeaderProps {
  destinationLabel?: string;
  toError?: string;
}

export const BuilderDestinationColumnHeader = ({
  destinationLabel = 'Destination',
  toError,
}: BuilderDestinationColumnHeaderProps) => (
  <>
    <Typography variant="h4" color={toError ? 'error' : 'primary'}>
      <strong>
        {destinationLabel}
        {toError ? ' (required)' : ''}:
      </strong>
    </Typography>
    <Box mt={1} />
  </>
);
